import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { LoadPagePanel } from '../../../../components';
import { useGetEstimate } from '../api/get-estimate';
import { EstimateContext, RefetchScope } from '../context/EstimateContext';
import { DealerEstimateContextType } from '../types/DealerEstimateContextType';


export default function EstimatePage(props: React.PropsWithChildren<unknown>) {

	const params = useParams();
	const quoteID = parseInt(params.quoteID!);

	const [orderState, setOrderState] = useState<DealerEstimateContextType>({} as DealerEstimateContextType);
	const { data: estimateData, isLoading, refetch, isRefetching } = useGetEstimate(quoteID);
	const [refetchScope, setRefetchScope] = useState<RefetchScope | undefined>();

	// Clear context on quote ID change 
	if (orderState.details && orderState.details.quoteID !== quoteID) {
		setOrderState({} as DealerEstimateContextType);
	}

	useEffect(() => {
		if (estimateData) {
			switch (refetchScope) {
				case RefetchScope.Files:
					setOrderState({
						details: { ...orderState.details, files: estimateData.files, confirmOrderSettings: {...orderState.details.confirmOrderSettings, files: estimateData.confirmOrderSettings.files} }, originalDetails: estimateData,
						modified: orderState.modified
					});
					break;

				case RefetchScope.Notes:
					setOrderState({
						details: { ...orderState.details, notes: estimateData.notes }, originalDetails: estimateData,
						modified: orderState.modified
					});
					break;

				default:
					setOrderState({ details: estimateData, originalDetails: estimateData, modified: false });
					break;
			}
		}
	}, [estimateData]);

	return (
		<React.Fragment>
			{
				orderState.details &&
				<EstimateContext.Provider value={{
					order: orderState,
					modifyOrder: (details) => setOrderState(
						{ ...orderState, details: details, modified: true }),
					refetchOrder: (scope?: RefetchScope) => {
						setRefetchScope(scope);
						return refetch();
					}
				}}>

					<div className={'content-block order-page'}>
						{props.children}
					</div>
				</EstimateContext.Provider>
			}

			<LoadPagePanel visible={isLoading || isRefetching} />
		</React.Fragment>)
}
